/**
 * @description 导出默认通用配置
 */
const setting = {
  //标题 （包括初次加载雪花屏的标题 页面的标题 浏览器的标题）
  title: "customization admin"
};
module.exports = setting